import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import IndexBar from '../layout/IndexBar';
import Default from './Default';

export default class Project extends Default {
  id;
  isWrapAutoRemove = true;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor() {
    super();
  }

  afterShow() {
    super.afterShow();
    IndexBar.toggleState();
  }

  beforeHide() {
    super.beforeHide();
    IndexBar.toggleState();
  }

  afterHide() {
    super.afterHide();
  }
}

ControllerPage._addPage("project", Project)
